var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.331,
    height: 12.277,
    viewBox: "0 0 10.331 12.277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-rotate-right",
    "data-name": "Icon material-rotate-right",
    d: "M13.491,4.451,10.54,1.5V3.491a5.183,5.183,0,0,0,0,10.286v-1.31a3.887,3.887,0,0,1,0-7.666V7.337Zm2.841,3.534A5.127,5.127,0,0,0,15.28,5.463l-.921.921a3.765,3.765,0,0,1,.661,1.6ZM11.837,12.46v1.31a5.139,5.139,0,0,0,2.529-1.044l-.934-.934A3.752,3.752,0,0,1,11.837,12.46Zm2.523-1.569.921.914a5.127,5.127,0,0,0,1.051-2.523h-1.31a3.824,3.824,0,0,1-.661,1.608Z",
    transform: "translate(-6 -1.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/Rotate.b45424c5b9237c56323b70b2d38ef255.svg";
export { ForwardRef as ReactComponent };